module.exports = __webpack_public_path__ + "img/foreground-01-1600x310.b2f5689a.png";